import { useEffect, useState } from 'react';
import { fetchSettings } from '@/api';

const DEFAULT_TIMEZONE = 'Africa/Windhoek';

export function useSystemTimezone(defaultTimezone: string = DEFAULT_TIMEZONE) {
  const [systemTimezone, setSystemTimezone] = useState<string>(defaultTimezone);

  useEffect(() => {
    let mounted = true;
    fetchSettings()
      .then((res) => {
        const timezone = res?.data?.timezone || res?.data?.data?.timezone;
        if (mounted && timezone) setSystemTimezone(timezone);
      })
      .catch(() => {
        // keep default on failure
      });
    return () => { mounted = false; };
  }, []);

  return systemTimezone;
}
